/***
 * File name: table.js
 *
 * Program Description:
 * This file contains all the meta configuration of the Notification Types master
 * data
 *
 * Includes the ff:
 * - Name, collection name, label and other static values for the table
 * - Route definitions
 * - Binded varibles
 * - Advanced query when fetching data list
 * - Privilege name for role restrictions
 * - Table columns indicated as fields
 * - Action buttons on top of the table indicated as tableActions
 * - Action buttons per item inside the table indicated as entryActions
 * - Breadcrumbs definition
 *
 */
export default function (vm) {
  return {
    name: 'NotificationType',
    collectionName: 'notificationType',
    dataView: 'default',
    label: 'Notification Type',
    tableHeader: 'Notification Types',
    route: {
      updateMultiple: 'notificationType',
      list: 'notificationType',
      deleteMultiple: 'notificationType',
      upload: 'notificationType'
    },
    vBind: {
      singleSelect: true
    },
    advancedQuery: {
      type: 'notificationType'
    },
    hideSelect: true,
    privilege: 'canViewAllNotificationType',
    fields: [
      {
        columnHeader: {
          sortable: true,
          text: 'Notification Type',
          value: 'value',
          cellClass: 'px-1',
          class: 'px-1'
        }
      }
    ],
    tableActions: [
      {
        id: 'create',
        label: 'Add',
        icon: 'mdi-plus',
        color: 'white',
        vBind: {
          style: 'background-color: #162b54'
        },
        privilege: 'canPostNotificationType',
        action: () => {
          vm.$emit('modalChange', 'create', 'notification type')
        }
      }
    ],
    entryActions: [
      {
        id: 'view',
        icon: 'mdi-eye',
        privilege: 'canViewNotificationType',
        action: (item) => {
          vm.$emit('modalChange', 'view', 'notification type', item._id)
        }
      },
      {
        id: 'edit',
        icon: 'mdi-pencil',
        privilege: 'canViewNotificationType',
        action: (item) => {
          vm.$emit('editRow', 'edit', 'notification type', item._id)
        }
      },
      {
        id: 'del',
        icon: 'mdi-delete',
        privilege: 'canDeleteNotificationType',
        action: (item) => {
          vm.$emit('deleteRow', 'delete', 'notification type', item._id)
        }
      }
    ],
    breadcrumbs: {
      divider: '/',
      large: true,
      items: [
        {
          text: 'Notification Type'
        }
      ]
    }
  }
}
